export default [
  {
    bank: 'Barclays',
    value: 10,
    limit: 30,
  },
  {
    bank: 'HSBC',
    value: 20,
    limit: 30,
  },
  {
    bank: 'Lloyds',
    value: 2,
    limit: 30,
  },
  {
    bank: 'Santander',
    value: 38,
    limit: 30,
  },
  {
    bank: 'RBS',
    value: 18,
    limit: 20,
  },
  {
    bank: 'SEB',
    value: 20,
    limit: 20,
  },
  {
    bank: 'BNY Mellon',
    value: 10,
    limit: 20,
  },
];
